import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { GatewaysActions } from './gateways.actions';
import { GatewaysState } from './gateways.state';

export const initGatewaysState: GatewaysState = {
  gateways: [],
  cursor: '',
  loading: false,
  loaded: false,
  error: null,
  searchParams: {
    gatewaySerial: '',
    limit: undefined,
    cursor: undefined,
  },
};

export const gatewaysReducer: ActionReducer<GatewaysState, Action> = createReducer(
  initGatewaysState,

  on(
    GatewaysActions.listGatewaysSearchResult,
    (_state, { gatewaySerial, expanded, includeDevices, limit, cursor }): GatewaysState => ({
      ...initGatewaysState,
      loading: true,
      loaded: false,
      searchParams: {
        gatewaySerial,
        expanded,
        includeDevices,
        limit,
        cursor,
      },
    })
  ),

  on(
    GatewaysActions.listGatewaysSearchResultSuccess,
    (state, { gateways, cursor }): GatewaysState => ({
      ...state,
      gateways,
      cursor,
      loading: false,
      loaded: true,
    })
  ),

  on(
    GatewaysActions.listGatewaysSearchResultError,
    (state): GatewaysState => ({
      ...state,
      loading: false,
      loaded: false,
    })
  ),

  on(
    GatewaysActions.listGatewaysSearchFetchMore,
    (state): GatewaysState => ({
      ...state,
      loading: true,
      loaded: false,
    })
  ),

  on(
    GatewaysActions.listGatewaysSearchFetchMoreSuccess,
    (state, { gateways, cursor }): GatewaysState => ({
      ...state,
      gateways: gateways ? [].concat(state.gateways, gateways) : state.gateways,
      cursor,
      loading: false,
      loaded: true,
    })
  ),

  on(
    GatewaysActions.listGatewaysSearchFetchMoreError,
    (state): GatewaysState => ({
      ...state,
      loading: false,
      loaded: false,
    })
  ),

  on(
    GatewaysActions.FetchGatewayActiveErrors,
    (state): GatewaysState => ({
      ...state,
      loading: true,
      loaded: false,
    })
  ),

  on(
    GatewaysActions.FetchGatewayActiveErrorsSuccess,
    (state, { activeErrors }): GatewaysState => ({
      ...state,
      gateways: state.gateways.map((gateway) => ({
        ...gateway,
        activeErrors: activeErrors[gateway.serial] ?? [],
      })),
      loading: false,
      loaded: true,
    })
  ),

  on(
    GatewaysActions.FetchGatewayActiveErrorsError,
    (state): GatewaysState => ({
      ...state,
      loading: false,
      loaded: false,
    })
  )
);
